<template>
  <div class="flex-column dialog-content" style="height:auto">
    <div class="flex justify-space-around tab-wrapper">
      <button @click="changeTab(1)" class="text-left tab--btn pointer" :class="{active:currentTab === 1}">外側に1石ダイヤ<br >留めまたは彫りのみ</button>
      <button @click="changeTab(2)" class="text-left tab--btn pointer" :class="{active:currentTab === 2}">外側にローズ<br>カットダイヤを留める</button>
      <button @click="changeTab(3)" class="text-left tab--btn pointer" :class="{active:currentTab === 3}">複数のダイヤ<br>を留める</button>
    </div>
  </div>
  <div class="sp-scroll dialog-content overflow-y">
    <div class="text-center diamond-color-wrapper" v-if="currentTab===1">
      <h3 class="diamond-title">ダイヤの色を選択する</h3>
      <div class="flex align-center justify-center button-wrapper">
        <button @click="setColor(null)"
                class="color--btn transparent pointer"
                :class="{active: !option}">
          <span :style="{backgroundColor:'#EDEDED'}"><img class="diaImage" :src="base+'/images/step7/dia-img/transparent.png'"></span>
        </button>
        <button @click="setColor('brown')"
                class="color--btn brown pointer"
                :class="{active: option === 'brown'}">
          <span :style="{backgroundColor:'#AD9898'}"><img class="diaImage" :src="base+'/images/step7/dia-img/brown.png'"></span>
        </button>
        <button @click="setColor('black')"
                class="color--btn black pointer"
                :class="{active: option === 'black'}">
          <span :style="{backgroundColor:'#050505'}"><img class="diaImage" :src="base+'/images/step7/dia-img/black.png'"></span>
        </button>
        <button @click="setColor('blue')"
                class="color--btn blue pointer"
                :class="{active: option === 'blue'}">
          <span :style="{backgroundColor:'#0064A2'}"><img class="diaImage" :src="base+'/images/step7/dia-img/blue.png'"></span>
        </button>
      </div>
      <h5 class="selected-color">{{option === 'brown'? "ブラウン": option === 'black'? "ブラック" : option === 'blue'? "ブルー" : "透明"}}</h5>
    </div>
    <h3 class="title text-center">留め方を選択する</h3>
    
    <div class="flex-wrap justify-space-between main-content overflow-y relative">
      <p v-if="currentTab === 3" class="tab3Note">※ダイヤモンドの間隔・大きさにつきましてはバランスを見て配置します。シミュレーション画像とは多少異なります</p>
      <figure v-for="(data, idx) in tabData"
              class="transition"
              :key="idx"
              :class="{active:selectedItem && selectedItem.val === data.val}">
        <div class="relative image-wrapper transition oval">
          <div class="flex chips">
            <span class="flex align-center justify-center title text-center">{{data.name}}</span>
            <button class="detail oval text-center pointer transition" @click="toggleSubDialog(data, true)">詳しく</button>
          </div>
          <p v-if="data.imgExplain" class="imgExplain">{{data.imgExplain}}</p>

          <img v-if="applyRule(data.val).visible" class="oval pointer" :src="currentImage(data).forDialogue" alt="image" @click="storeItem(data, option)">

          <!-- ルールのエラーが出れば表示させる画像 -->
          <div v-else-if="!applyRule(data.val).visible" class="relative substitute">
            <p v-if="data.imgExplain" class="imgExplain">{{data.imgExplain}}</p>
            <img class="oval pointer" :src="currentImage(data).forDialogue" alt="image">
          </div>
          <!-- ルールのエラー表示 -->
          <div v-if="!applyRule(data.val).visible" class="flex align-center justify-center select-button rule-text">
            <div class="overlay"></div>
            <p class="warning">選択できません<br>{{applyRule(data.val).rule}}</p>
          </div>
          <transition name="slideUp">
            <div class="flex align-center justify-center select-button" v-if="selectedItem && selectedItem.val === data.val">
              <div class="overlay"></div>
              <button class="oval transition pointer" @click="removeItem(selectedItem)">選択解除</button>
              <button class="oval transition pointer btn-black" @click="selectItem(data.val)">選択</button>
            </div>
          </transition>
        </div>
      </figure>
    </div>
  </div>
</template>

<script>
import {onMounted, ref,watch} from "vue";
import useDialogBuilder from "@/modules/moduleA/helpers/useDialogBuilder";
import useImageBuilder from "@/modules/moduleA/helpers/useImageBuilder";
import useRules from "@/modules/moduleA/helpers/useRules";
import {PATH_HANDLER} from "@/config";

export default {
  name: "DiType4",
  props:{stepData:Array},
  setup(props){
    const {currentRoute, toggleSubDialog, storeItem, selectItem, removeItem, selectedItem, results} = useDialogBuilder()
    const {currentImage} = useImageBuilder(currentRoute.value)
    const {applyRule} = useRules(currentRoute.value)
    const currentTab = ref(1)
    const tabData = ref([])
    const option = ref(null)
    const base = ref(PATH_HANDLER.path)

    onMounted(() => {
      // results.value.forEach(item => {
      //   if(item.step === 7){
      //     if(selectedItem && !selectedItem.value.option){
      //       console.log(selectedItem.value)
      //       option.value = "transparent"
      //     } 
      //     // else if (item.option && item.option === "transparent"){
      //     //   option.value = "transparent"
      //     // } else if (item.option && item.option !== "transparent") {
      //     //   option.value = item.option
      //     // }
      //   }
      // })

    })

    tabData.value = props.stepData.filter(item => {
      return item.tab === currentTab.value
    })

    if (selectedItem.value){
      currentTab.value = selectedItem.value.tab
      option.value = selectedItem.value.option
      tabData.value = props.stepData.filter(item => {return item.tab === selectedItem.value.tab})
    }

    const changeTab = (tab) => {
      if(tab){
        if(tab===1){
          //option.value = 'transparent'
        }else{
          //option.value = null
        } 
      }
      currentTab.value = tab
      tabData.value = props.stepData.filter(item => {return item.tab === tab})
    }
   

    watch(() => option.value, (val) => {
      if (selectedItem.value){
        if (val){
          storeItem(selectedItem, val)
        } else {
          // selectedItem.value.val = selectedItem.value.val.split("_")[0]
          selectedItem.value.option = val
          storeItem(selectedItem)
        }
      }
    })

    const setColor = (val) => {
      option.value = val
    }

    return {currentRoute, toggleSubDialog, storeItem, selectItem, removeItem, selectedItem, currentImage, applyRule,
      currentTab, tabData, changeTab, option, setColor, base,
    }

  }
}
</script>

<style scoped>
.diaImage{max-width: 100%;}
.dialog-content > .main-content > figure > .image-wrapper > .select-button > button.btn-black{
  background-color: #1e272e;
  border: 1px solid #f5f6fa;
  color: #f5f6fa;
}
.dialog-content > .main-content > figure > .image-wrapper .imgExplain {
  position: absolute;
  top: 60px;
  right: 15px;
  font-size: .8rem;
  color: #171717;
}
.dialog-content .tab3Note {
  position: absolute;
  top: 0;
  text-align: center;
  font-size: .75rem;
  color: #797979;
}
@media screen and (max-width: 736px) {
  .overlay > .window > .content > .dialog-content {
    height: 100%;
    overflow-y: scroll;
    display: block;
  }
  .overlay > .window > .content > .dialog-content > .main-content {
    padding: 0 0 50px;
    height: auto;
  }
  .dialog-content > .main-content > figure > .image-wrapper > .chips > span.title {
    font-size: 1.1rem;
  }
  .dialog-content .tab3Note {
    position: static;
    margin-bottom: 10px;
  }
}
</style>
